import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { addScreenedFund } from '../../../actions'
import { useSelector } from 'react-redux'
import i18n from '../../../i18n'
import Selector from 'wt-react/dist/components/Selector/Selector'

const StrategySelect = ({ strategiesToList }) => {
  const dispatch = useDispatch()
  const screenedFunds = useSelector(state => state.params.screenedFunds)
  const selectedIds = screenedFunds.map(fund => fund.id)

  const setPortfolio = useCallback(
    key => {
      const [selectedStrategy] = strategiesToList.filter(strategy => strategy.id === key)
      const { id, name, periodicity, holdings } = selectedStrategy
      const externalID = id
      const ticker = holdings[holdings.length - 1].tickers.join(',')
      const type = 'user_model'
      const rebalance_fq = periodicity
      const filteredFund = { id, externalID, ticker, rebalance_fq, name, type }
      dispatch(addScreenedFund(filteredFund))
    },
    [strategiesToList, dispatch]
  )

  if (!strategiesToList || strategiesToList.length === 0 || strategiesToList === '') {
    return null
  }

  const options = strategiesToList
    .filter(strategy => !selectedIds.includes(strategy.id))
    .map(strategy => ({
      value: strategy.id,
      label: strategy.name
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
    <div style={{ marginBottom: screenedFunds.length > 0 ? 0 : 20 }}>
      <Selector 
        isMulti 
        options={options} 
        onChange={e => setPortfolio(e[0].value)} 
        placeholder={i18n.t('search-portfolio')} 
        noOptionsMessage={() => null} 
        components={{ IndicatorSeparator: null }} 
        closeMenuOnSelect={true} 
        blurInputOnSelect={false} 
        clearable={true} 
        value={''} 
      />
    </div>
  )
}

export default StrategySelect
